<template>
	<div id="worksends-bar" :class="'bar-'+type+' position-'+position">
		<div class="bar-inner" v-if="type=='demo'">
			<div class="bar-text">
				<h4>
					Welcome To Bookblock HUB <i>Preview Mode</i>. 
				</h4>
				<p>
					You're viewing the Bookblock HUB platform in <i>Preview Mode</i>. You can preview all sections of the Bookblock HUB platform 
					but you will not be able to create campaigns, send gifts or take any other actions. 
					In order to do so you need to create an account.
				</p>
			</div>
			<div class="bar-button">
				<a class="ws-button ws-button-white" @click="openRegistrationModal">Sign Up To Bookblock HUB</a>
			</div>			
		</div>
		
		<div class="bar-inner" v-if="type=='on-demand'">
			<div class="bar-text">
				<h4>
					Welcome To Bookblock HUB <i>ON DEMAND</i>. 
				</h4>
				<p>
					With <i>ON DEMAND</i> you can send as many <a href="/pro/marketplace/">physical gifts</a> from our Marketplace as you want.<br>
					Upgrade to <b>Bookblock HUB PRO</b> for gifting campaigns, corporate products, unlimited teams and much more.
				</p>
			</div>
			<div class="bar-button">
				<a class="ws-button ws-button-white" @click="openRegistrationModal">Upgrade To Bookblock HUB PRO</a>
			</div>			
		</div>
		
		<div class="bar-inner" v-if="type=='trial'">
			<div class="bar-text">
				<h4>
					<b>Bookblock HUB Pro</b> request pending...
				</h4>
				<p>
					We have received your request for Bookblock HUB Pro and it's being processed. <b>A Bookblock HUB Account Manager will be in touch soon.</b><br />
					In the meantime you can still enjoy <i>ON DEMAND</i> benefits of sending <a href="/pro/marketplace/">physical gifts</a> from our Marketplace.<br>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FullWidthBar',
	props: ['type','position'],
	data() {
		return {
			
		}
	},
	methods: {
        openRegistrationModal() {
			this.modals.registrationModal = true;
		},
    },
	mounted() {
		
    },
	computed: {
		modals() {
            return this.$store.state.modals;
        },
	}
}
</script>